import { OverlayModule } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

import { DsModal, DsModalContent } from '@frontend/ui/modal';
import { ElementKeyDirective } from '@frontend/vanilla/core';

import { CashierIframeComponent } from '../cashier-iframe.component';
import { CashierIframeEvent } from '../cashier-iframe.models';
import { QuickDepositResponsiveComponent } from './quick-deposit-responsive.component';

@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [OverlayModule, ElementKeyDirective, CashierIframeComponent, DsModal, DsModalContent],
    selector: 'lh-quick-deposit-responsive-iframe',
    templateUrl: './quick-deposit-iframe.component.html',
    styleUrl: '../../../../../../themepark/themes/whitelabel/components/quick-deposit/styles.scss',
    encapsulation: ViewEncapsulation.None,
})
export class QuickDepositIframeComponent extends QuickDepositResponsiveComponent implements OnInit {
    override async ngOnInit(): Promise<void> {
        await super.ngOnInit();
    }

    override close(message: CashierIframeEvent) {
        super.close(message);
    }

    override resize(message: CashierIframeEvent) {
        super.resize(message);
    }
}
